const MILLISECONDS_IN_DAY = 86400000;

function daysToMilliseconds(days) {
  return days * MILLISECONDS_IN_DAY;
}

// set cookie max age to 400 days according to
// http working group draft-ietf-httpbis-rfc6265bis
// https://httpwg.org/http-extensions/draft-ietf-httpbis-rfc6265bis.html#name-the-max-age-attribute
const COOKIE_MAX_DAYS = 400;
const COOKIE_MAX_MILLISECONDS = daysToMilliseconds(COOKIE_MAX_DAYS);

function getExpiration(millisecondsToExpire = MILLISECONDS_IN_DAY) {
  const currentDate = new Date().valueOf();
  const expires = new Date(currentDate + millisecondsToExpire);
  return expires;
}

const COOKIE_EXPIRATION = getExpiration();
export const MAX_COOKIE_EXPIRATION = getExpiration(COOKIE_MAX_MILLISECONDS);

export function cookiesAreSupported() {
  try {
    return navigator.cookieEnabled;
  } catch {
    return false;
  }
}

export function getCookie(name) {
  const cookies = document.cookie.split(";");
  const cookie = cookies.find((c) => c.includes(name));

  return cookie || null;
}

export function getCookieValue(name) {
  const cookie = getCookie(name);

  if (!cookie) return null;

  const cookieArray = cookie.split("=");

  if (cookieArray.length !== 2) return null;

  const cookieValue = cookieArray[1].trim();

  return cookieValue;
}

export function setCookie(name, value, expiration = COOKIE_EXPIRATION) {
  document.cookie = `${name}=${value}; Secure; SameSite=Lax; Expires=${expiration}; Path=/`;
}

export function createCookieIfNotExists(name, value) {
  const cookie = getCookie(name);

  if (!cookie) setCookie(name, value);
}

export const REMAINING_PAGE_VIEWS = "8m5RsAbKEpSlMNr9bPdh";
export const MAX_PAGE_VIEWS = 5;

export function getRemainingPageViews() {
  createCookieIfNotExists(REMAINING_PAGE_VIEWS, MAX_PAGE_VIEWS);
  const pageViewString = getCookieValue(REMAINING_PAGE_VIEWS);

  try {
    return parseInt(pageViewString);
  } catch {
    return 0;
  }
}
